<div class="container-fluid mt-3 mb-3 theme">
  <div class="row nowrap mt-4 mb-3" aria-label="breadcrumb">
    <div class="col-lg-10">
      <div class="d-flex">
        <h1>Cyber Auditor Registration</h1>
        <ul class="breadcrumbcustom" role="navigation" aria-labelledby="breadcrumb">
          <li><a routerLink="">Home</a></li>
          <li><a routerLink="">Cyber Audit Registration</a></li>
          <li class="active"><a routerLink="#" aria-current="page">Cyber Auditor Registration</a></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="card card-body">
    <form [formGroup]="filterForm">


      <div class="row">

        <div class="col-lg-2 form-group">
          <label>Auditor Name</label>
          <select class="form-control selectpicker" formControlName="nature" data-style="btn-info"
            title="Auditor Name" (change)="OnChangeOfName()" >
            @for (data of auditorAllDtls; track data) {
              <option value="{{data.audtiorName}}">{{data.audtiorName}}</option>
            }
          </select>
        </div>
        <div class="col-lg-2 form-group">
          <label>Auditor Frim Name</label>
          <select class="form-control selectpicker" formControlName="frmName" data-style="btn-info"
            title="Auditor Firm Name" (change)="OnChangeOfFirm()">
            @for (data of auditorAllDtls; track data) {
              <option >{{data.firmname}}</option>
            }
          </select>
        </div>

        <div class="col-lg-2">
          <label>&nbsp;</label>
          <button class="form-control btn-primary" (click)="filter()">Search</button>
        </div>

        <div class="col-lg-2">
          <label>&nbsp;</label>
          <button class="form-control btn-cancel"  (click)="resetDetails()">Reset</button>
        </div>

      </div>

    </form>
  </div>
  <hr>
    <div class="card card-body colorborder ">

      <div class="row">
        <div class="col-lg-10"></div>
        <div class="col-lg-2">
            <button class=" form-control btn-primary float-right" data-toggle="modal" data-target="#newAuditor" (click)="resetEditableData()">New
          Auditor</button>
        </div>
      </div>

      <!-- <table id="MIS" class="overflow table common-table nowrap" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"> -->
      <table id="auditorMis" class="overflow table common-table" datatable [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger">
        <thead>
          <tr>
            <th>Auditor Period</th>
            <th>Auditor Login Id.</th>
            <th>Auditor Membership No</th>
            <th>Firm Name</th>
            <th>Auditor Name</th>
            <th>Auditor Firm Registration No</th>
            <th>Qualificatiion</th>
            <th>Email Id</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
          <tr class="column-search">
            <th><input type="text" class="form-control form-control-sm" /></th>
            <th><input type="text" class="form-control form-control-sm" /></th>
            <th><input type="text" class="form-control form-control-sm" /></th>
            <th><input type="text" class="form-control form-control-sm" /></th>
            <th><input type="text" class="form-control form-control-sm" /></th>
            <th><input type="text" class="form-control form-control-sm" /></th>
            <th><input type="text" class="form-control form-control-sm" /></th>
            <th><input type="text" class="form-control form-control-sm" /></th>
            <th></th>
            <th></th>
          </tr>


        </thead>
        <tbody>

          @for (data of auditorDetails; track data) {
            <tr>
              <!-- <td (click)="open(data.mrcRefNum)" class="refNo pointer "><u>{{data.mrcRefNum}}</u></td> -->
              <td>{{data.auditPeriod}}</td>
              <td>{{data.auditorLoginId}}</td>
              <td>{{data.auditorMembershipNo}}</td>
              <td>{{data.firmname}}</td>
              <td>{{data.audtiorName}}</td>
              <td>{{data.auditorRegistrationNo}}</td>
              <td>{{data.qualitfication}}</td>
              <td>{{data.emailid}}</td>
              <td>
                @if (data.status=='OPEN') {
                  <i    (click)="creatEditobject(data.auditorLoginId)" class="fa fa-pencil"  aria-hidden="true"
                  data-toggle="modal" data-target="#newAuditor" data-backdrop="static" data-keyboard="false"></i>
                }
              </td>
              <td>
                @if (data.status=='OPEN') {
                  <i   (click)="removeSystemAuditPeriodMapping(data.memid,data.caId)"  class="fa fa-trash" aria-hidden="true"
                  data-backdrop="static" data-keyboard="false"></i>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal fade" id="newAuditor" tabindex="-1" role="dialog" aria-labelledby="newAuditorRegistration"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Cyber Auditor</h5>
        </div>
        <button type="button" class="close close-position" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="container-fluid mt-3 mb-3 theme">
          <form [formGroup]="auditorRegistrationPage" ngNativeValidate>

            <div class="card card-body col-lg-12 mt-3 colorborder">
              <div class="row">
                <div class="col-lg-2 form-group mx-3 my-1">
                  <label class="font-size">Audit Period &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;:</label>
                </div>
                <div class="col-lg-3 form-group">

                  <select formControlName="auditPeriod" class="form-control selectpicker" title="Select Audit Period">
                    @for (prd of PeriodArray; track prd) {
                      <option value="{{prd}}">{{prd}}</option>
                    }
                  </select>


                </div>

                <div class="col-lg-2 form-group mx-3 my-1">
                  <label class="font-size">Member Catogory &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;:</label>
                </div>
                <div class="col-lg-3 form-group">

                  <input type="text" value="" class="form-control" formControlName="memberCatogory"
                    readonly>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-2 form-group mx-3 my-1">
                    <label class="font-size">Auditor Login Id &nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;:</label>
                  </div>
                  <div class="col-lg-3 form-group">
                    <!-- <select formControlName="loginId" class="form-control selectpicker"  title="Select Auditor Login id" (change)="isConssecutiveSubmisstion()">
                    <option *ngFor="let auditor of auditorDtlsArray" value="{{auditor.auditorId}}">
                    {{auditor.auditorId}}</option>
                  </select> -->

                  <select [(ngModel)]="selectedLoginIdValue" formControlName="loginId" class="form-control"
                    title="Select Auditor Login id" (change)="isConssecutiveSubmisstion()">
                    <option value="">Select Auditor Login id</option>
                    @for (auditor of auditorDtlsArray; track auditor) {
                      <option [value]="">
                      {{auditor.auditorId}}</option>
                    }
                  </select>
                </div>
                <div class="col-lg-2 form-group mx-3 my-1">
                  <label class="font-size">Auditor Membership No</label>
                </div>
                <div class="col-lg-3 form-group">
                  <input type="text" value="" class="form-control" formControlName="auditorMembershipNo"
                    required>
                    @if (f.auditorMembershipNo.invalid && f.auditorMembershipNo.touched) {
                      <div>
                        @if (f.auditorMembershipNo.errors.required) {
                          <p class="error nocase">
                            Please Enter the Membership Number
                          </p>
                        }
                        @if (f.auditorMembershipNo.errors.pattern) {
                          <p  class="error nocase">Enter Only Numbers</p>
                        }
                      </div>
                    }
                  </div>
                </div>

                <div class="row">

                  <div class="col-lg-2 form-group mx-3 my-1">
                    <label class="font-size">Auditor Name </label>
                  </div>
                  <div class="col-lg-3 form-group">
                    <input type="text" value="" class="form-control" formControlName="auditorName" required>
                    @if (f.auditorName.invalid && f.auditorName.touched) {
                      <div>
                        @if (f.auditorName.errors.required) {
                          <p class="error nocase">
                            Please Enter the Name
                          </p>
                        }
                        @if (f.auditorName.errors.pattern) {
                          <p  class="error nocase">Enter Only Character</p>
                        }
                      </div>
                    }
                  </div>

                  <div class="col-lg-2 form-group mx-3 my-1">
                    <label class="font-size">Auditor Firm Name&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;:</label>
                  </div>
                  <div class="col-lg-3 form-group">
                    <input type="text" value="" class="form-control" formControlName="auditorFirmName"
                      required>
                      @if (f.auditorFirmName.invalid && f.auditorFirmName.touched) {
                        <div>
                          @if (f.auditorFirmName.errors.required) {
                            <p class="error nocase">
                              Please Enter the Firm NAme
                            </p>
                          }
                        </div>
                      }
                    </div>
                  </div>

                  <div class="row">


                    <div class="col-lg-2 form-group mx-3 my-1">
                      <label class="font-size">Auditor Firm Registration No&nbsp;
                      &nbsp;&nbsp;&nbsp;&nbsp;:</label>
                    </div>
                    <div class="col-lg-3 form-group">
                      <input type="text" value="" class="form-control"
                        formControlName="auditorFirmRegistrationNo" required>
                        @if (f.auditorFirmRegistrationNo.invalid && f.auditorFirmRegistrationNo.touched) {
                          <div>
                            @if (f.auditorFirmRegistrationNo.errors.required) {
                              <p class="error nocase">
                                Please Enter the Registration Number
                              </p>
                            }
                            @if (f.auditorFirmRegistrationNo.errors.pattern) {
                              <p  class="error nocase">Only AplhaNumeric Charcaters Allowed</p>
                            }
                          </div>
                        }
                      </div>
                      <div class="col-lg-2 form-group mx-3 my-1">
                        <label class="font-size">Auditor Qualificatiion</label>
                      </div>
                      <div class="col-lg-3 form-group">
                        <select class="form-control selectpicker" formControlName="auditorQualification"
                          title="Select Qualification">
                          @for (edu of education; track edu) {
                            <option value="{{edu}}">{{edu}}</option>
                          }
                        </select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-2 form-group mx-3 my-1">
                        <label class="font-size">Auditor Email Id
                        &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;:</label>
                      </div>
                      <div class="col-lg-3 form-group">
                        <input type="text" value="" class="form-control" formControlName="auditorEmailId"
                          required>
                          @if (f.auditorEmailId.invalid && f.auditorEmailId.touched) {
                            <div>
                              @if (f.auditorEmailId.errors.required) {
                                <p class="error nocase">
                                  Please Enter the Email Id
                                </p>
                              }
                              @if (f.auditorEmailId.errors.email) {
                                <p  class="error nocase">Email is invalid</p>
                              }
                            </div>
                          }
                        </div>
                      </div>
                      <div class="row justify-content-start">
                        @if (isEditable) {
                          <div class="col-lg-2">
                            <button type="submit" class="btn btn-primary full-width" [disabled]="auditorRegistrationPage.invalid"  (click)="onSubmit()"
                            data-dismiss="modal">Submit</button>
                          </div>
                        }
                        @if (isEditable) {
                          <div class="col-lg-2">
                            <button class="btn btn-cancel full-width" (click)="reset()">Reset</button>
                          </div>
                        }

                        @if (!isEditable) {
                          <div class="col-lg-2">
                            <button type="submit" class="btn btn-primary full-width"
                            (click)="onUpdate()">Update</button>
                          </div>
                        }

                      </div>

                    </div>



                  </form>



                </div>

              </div>
            </div>
          </div>